export default "__VITE_ASSET__CKqBRD7K__"